import { OnInit, Component, Input } from '@angular/core';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { PlanCompensatorioModel } from 'src/app/models/planCompensatorio.model';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { UtilService } from 'src/app/shared/services/util.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { GlobalService } from 'src/app/shared/global.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';

@Component({
    selector: 'app-informacion-inscripcion',
    templateUrl: './informacion-inscripcion.component.html',
    styleUrls: ['./../plan-compensatorio.component.scss']
})
export class InformacionInscripcionComponent implements OnInit {

    @Input() infoInscripcion: PlanCompensatorioModel;

    public placeholderDate: string;
    festivos = [];

    constructor(
        private urlService: UrlService,
        private global: GlobalService,
        private alertService: AlertService,
        private spinner: NgxSpinnerService,
        private utilService: UtilService
    ) {
    }

    ngOnInit() {
        this.consultarFestivos();
        this.placeholderDate = ConstantesService.SELECCION_FECHA;
    }


    /**
    * Método que valida las fechas con los festivos
    */
    public consultarFestivos() {
        const serviceProvider = 'consultarFestivos';
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.festivos = data;
            }, err => {
                this.cathException('No es posible Obtener los festivos');
            });
    }

    /**
    * Método de control de Excepciones
    * @param error mensaje saliente respecto al error ocurrido
    */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }

    validarFestivos(event, atributo) {
        this.infoInscripcion[atributo] = event;
        const fecha = moment(event).format(ConstantesService.FORMATO_FECHA_ISO)
        if (this.festivos.find((x: string) => moment(x).format(ConstantesService.FORMATO_FECHA_ISO) === fecha)) {
            this.cathException('Las fechas de compensación no pueden ser días festivos, por favor verifique');
            return;
        }

    }

}
